module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/arrow_down-78db67e46651b4bd2c85afb2ac904b26.svg";